import { invoke } from '@tauri-apps/api/core';

export function bytesToBase64(bytes) {
    const chunkSize = 65536;
    let binary = '';
    for (let offset = 0; offset < bytes.length; offset += chunkSize) {
        binary += String.fromCharCode.apply(null, bytes.subarray(offset, offset + chunkSize));
    }
    return btoa(binary);
}

export function dataUrlToBase64(dataUrl) {
    return dataUrl.replace(/^data:[^;]+;base64,/, '');
}

export function deviceHttpArgs(plate) {
    return {
        host: plate.host || `${plate.name}.local`,
        native: plate.native === true,
        // Physical devices always use port 80. Native builds may use a
        // configurable HTTP port, defaulting to 8080.
        port: plate.native === true ? (Number(plate.http_port) || 8080) : 80,
        user: plate.user || '',
        pass: plate.pass || '',
        context: '',
    };
}

export function deviceTelnetArgs(plate) {
    return {
        addr: plate.host || `${plate.name}.local`,
        port: plate.native === true ? (Number(plate.telnet_port) || 2323) : 23,
    };
}

function splitVirtualPath(virtualPath) {
    const slash = virtualPath.lastIndexOf('/');
    return {
        path: virtualPath.slice(0, slash + 1),
        filename: virtualPath.slice(slash + 1),
    };
}

export async function uploadDeviceFile(plate, virtualPath, base64data, invokeImpl = invoke) {
    const { path, filename } = splitVirtualPath(virtualPath);
    return invokeImpl('http_transfer_file_command', {
        connArgs: deviceHttpArgs(plate),
        path,
        filename,
        base64data,
    });
}

export function listDeviceFiles(plate, path = 'L:/', invokeImpl = invoke) {
    return invokeImpl('http_transfer_list_files_command', {
        connArgs: deviceHttpArgs(plate),
        path,
    });
}

export function downloadDeviceFile(plate, virtualPath, invokeImpl = invoke) {
    const { path, filename } = splitVirtualPath(virtualPath);
    return invokeImpl('http_transfer_download_file_command', {
        connArgs: deviceHttpArgs(plate),
        path,
        filename,
    });
}

export function deleteDeviceFile(plate, virtualPath, invokeImpl = invoke) {
    const { path, filename } = splitVirtualPath(virtualPath);
    return invokeImpl('http_transfer_delete_file_command', {
        connArgs: deviceHttpArgs(plate),
        path,
        filename,
    });
}

export async function uploadDesignFiles(plate, resources, pagesBase64, upload = uploadDeviceFile) {
    for (const resource of resources) {
        await upload(plate, `L:/${resource.filename}`, resource.base64data);
    }
    await upload(plate, 'L:/pages.jsonl', pagesBase64);
}
